import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login.component';
import { LoginRoutingModule } from './login-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ForgetPasswordComponent } from '../components/forget-password/forget-password.component';
import { AlertModule, AlertConfig } from 'ngx-bootstrap/alert';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [
    LoginComponent, ForgetPasswordComponent
  ],
  imports: [
    CommonModule, LoginRoutingModule,FormsModule,
    ReactiveFormsModule, AlertModule, SharedModule
  ],
  exports: [LoginComponent, ForgetPasswordComponent],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  providers: [AlertConfig]
})
export class LoginModule { }
